// extracted by mini-css-extract-plugin
export default {"actions":"FeedDetailProductCard_actions__4bkKm"};